<template>
    <nav class="flex" aria-label="Breadcrumb">
        <ol class="inline-flex items-center ">
            <li v-for="crumb,crumbIndex in routesArray" :key="crumbIndex">
                <div class="flex items-center">
                    <div>
                        <a :class="crumbIndex == (routesArray.length-1)?'pointer-events-none text-gray-700':''" href="#" @click="navigate(crumb)" class="crumbSize font-medium text-gray-700 hover:text-primary">{{crumb.name}}</a>
                    </div>
                    <div v-if="crumbIndex !== (routesArray.length-1)">
                        <img src="@/assets/rightArrowFilled.svg" class="w-2.5 h-2.5 mx-1.5 mt-1 text-gray-400" />
                    </div>
                </div>
            </li>
            <div v-if="navIndexNums">
                <img src="@/assets/rightArrowFilled.svg" class="w-2.5 h-2.5 mx-1.5 mt-1 text-gray-400" />
            </div>
            <div v-if="navIndexNums">
                <a class='crumbSize font-medium disabled pointer-events-none' href="#">{{navIndexNums.name}}</a>
            </div>
        </ol>
    </nav>   
</template>
<style scoped>
.crumbSize {
    font-size: 12px;
    line-height: 16px;
}
.text-gray-700{
    color: #4d4d4d;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import { emitter } from '@/main';

export default defineComponent({
    props: ['routesArray','navIndexNums'],
    data(): any {
        return {
            navIndexes:{},
        };
    },
    
    methods:{
        navigate(crumb:any){
            if(Object.keys(crumb).includes('id')){
                this.$router.push({ name: crumb.routeName, params: { riskId: crumb.id } });
            }else{
                this.$store.dispatch('selectedRoute', crumb.name);
                this.$router.push({ name: crumb.routeName });
            }
        }
    }
})
</script>
